<template>
	<router-link
        :to="unidade.status == 'ativo' ? ('/v2/unidades/' + unidade.id) : 'javascript:void(0)'"
        class="tw-m-2 tw-inline-block"
        :class="unidade.status == 'ativo' ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'"
    >
        <div 
			class="tw-relative tw-w-80 tw-h-64 tw-rounded-2xl tw-overflow-hidden hover:tw-shadow-xl"
			:class="[unidade.status == 'ativo' ? 'tw-shadow-lg hover:tw-scale-105' : 'tw-shadow-md tw-opacity-75', theme === 'dark' ? 'tw-bg-slate-800' : 'tw-bg-white']"
			:style="{ '--bg-image': `url(${getImageUrl(unidade.imagem)})` }"
		>
            <div 
				class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-28 tw-bg-cover tw-bg-center"
				:style="{ backgroundImage: 'var(--bg-image)' }"
			>
			</div>
            <div class="tw-absolute tw-top-16 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-z-10">
                <img 
					:src="getImageUrl(unidade.logo)" 
					:alt="unidade.nome" 
					:class="theme === 'dark' ? 'tw-border-slate-800' : 'tw-border-white'"
					class="tw-bg-white tw-w-24 tw-h-24 tw-rounded-full tw-object-cover tw-border-2"
				/>
            </div>
            <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-32 tw-pt-6 tw-px-4 tw-flex tw-flex-col tw-items-center tw-justify-center">
                <span :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-green-600'" class="tw-text-lg tw-font-bold tw-text-center tw-line-clamp-2 tw-uppercase tw-tracking-wide tw-mb-4">
					{{unidade.nome}}
				</span>
            </div>
			<div v-if="unidade.status == 'inativo'" class="tw-absolute tw-inset-0 tw-bg-black/60 tw-flex tw-items-center tw-justify-center tw-rounded-2xl tw-z-50">
				<span class="tw-text-white tw-text-2xl tw-font-bold tw-tracking-widest">DESABILITADA</span>
			</div>
        </div>
    </router-link>
</template>

<script>
	import { defineComponent } from "vue";
	import { mapState } from 'vuex';


	export default defineComponent({
		props: {
			unidade: {
				type: Object,
				required: true,
			},
		},
        methods: {
            getImageUrl(imagePath) {
                return `${process.env.VUE_APP_SERVER}/storage/${imagePath}`;
            },
        },
		computed: {
			...mapState({
				theme: state => state.ui.theme,
			}),
		},
	});
</script>
